import { render, staticRenderFns } from "./ConcernedAboutVaccination.vue?vue&type=template&id=6912fa67&"
import script from "./ConcernedAboutVaccination.vue?vue&type=script&lang=js&"
export * from "./ConcernedAboutVaccination.vue?vue&type=script&lang=js&"
import style0 from "./ConcernedAboutVaccination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports